var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInactiveHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00012 13.7504C5.27512 13.7504 3.77212 13.1784 2.49112 12.0344C1.20962 10.8909 0.475122 9.46287 0.287622 7.75037H1.82512C2.00012 9.05037 2.57812 10.1254 3.55912 10.9754C4.54062 11.8254 5.68762 12.2504 7.00012 12.2504C8.46262 12.2504 9.70312 11.7409 10.7216 10.7219C11.7406 9.70337 12.2501 8.46287 12.2501 7.00037C12.2501 5.53787 11.7406 4.29712 10.7216 3.27812C9.70312 2.25962 8.46262 1.75037 7.00012 1.75037C6.13762 1.75037 5.33137 1.95037 4.58137 2.35037C3.83137 2.75037 3.20012 3.30037 2.68762 4.00037H4.75012V5.50037H0.250122V1.00037H1.75012V2.76287C2.38762 1.96287 3.16587 1.34412 4.08487 0.906616C5.00337 0.469116 5.97512 0.250366 7.00012 0.250366C7.93762 0.250366 8.81587 0.428366 9.63487 0.784366C10.4534 1.14087 11.1659 1.62212 11.7724 2.22812C12.3784 2.83462 12.8596 3.54712 13.2161 4.36562C13.5721 5.18462 13.7501 6.06287 13.7501 7.00037C13.7501 7.93787 13.5721 8.81587 13.2161 9.63437C12.8596 10.4534 12.3784 11.1659 11.7724 11.7719C11.1659 12.3784 10.4534 12.8599 9.63487 13.2164C8.81587 13.5724 7.93762 13.7504 7.00012 13.7504ZM9.10012 10.1504L6.25012 7.30037V3.25037H7.75012V6.70037L10.1501 9.10037L9.10012 10.1504Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInactiveHistory);
export default __webpack_public_path__ + "static/media/iconInactive-history.508889e97c93a89cffcd74c19e14fa18.svg";
export { ForwardRef as ReactComponent };